<template lang="pug">
    v-form.c-form(@submit.prevent="submit")

        // Email field
        v-text-field(
            type="email"
            name="username"
            :label="$t('fields.email')"
            :class="{ 'v-input--is-dirty': dirtyEmail }"
            v-model.lazy="model.username"
            v-validate="'required'"
            :data-vv-as="$t('fields.email')"
            :error-messages="errors.collect('username')"
            outlined
        )

        // Password field
        v-text-field(
            name="password"
            :type="visibility ? 'text' : 'password'"
            :label="$t('fields.password')"
            :class="{ 'v-input--is-dirty': dirtyPwd }"
            v-model.lazy="model.password"
            v-validate="'required|min:8|max:64'"
            :data-vv-as="$t('fields.password')"
            :error-messages="errors.collect('password')"
            :append-icon="visibility ? 'visibility' : 'visibility_off'"
            outlined
            @click:append="() => (visibility = !visibility)"
        )

        div
            // Submit button
            v-btn.mx-0.submit(
                large
                type="submit"
                color="primary"
                :action="submit"
                :isLoading="isLoading"
            ) {{ $t('auth.login.button') }}


        div.full-width
            separator-component

        div.linksWrapper.mt-2
            div

                // Redirect to reset password page
                router-link.link(a to="/forgot-password") {{ $t('auth.login.link') }}

            div

                // Sign Up link
                router-link.link(
                    tag="a"
                    to="/sign-up"
                ) {{ $t('auth.login.signUpNow') }}
</template>

<script>
    import { Separator } from '~components';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        $_veeValidate: {
            validator: 'new',
        },
        components: {
            SeparatorComponent: Separator,
        },
        data() {
            return {
                model: {
                    username: null,
                    password: null,
                },
                interval: null,
                dirtyEmail: null,
                dirtyPwd: null,
                visibility: false,
            };
        },
        computed: {
            ...mapGetters('auth', ['isLoading']),
        },
        mounted() {
            let times = 0;
            this.interval = setInterval(() => {
                times += 1;
                if ((this.dirtyEmail && this.dirtyPwd) || times === 20) {
                    clearInterval(this.interval);
                }
                this.dirtyEmail = document.querySelector(
                    'input[type="email"]:-webkit-autofill'
                );
                this.dirtyPwd = document.querySelector(
                    'input[type="password"]:-webkit-autofill'
                );
            }, 100);

            const dict = {
                custom: {
                    email: {
                        email: 'Invalid Email',
                        required: 'Email field is required',
                    },
                    password: {
                        required: 'Password field is required',
                        min: 'Your Password must be at least 8 characters.',
                        max: 'Your Password may not be greater than 24 characters',
                    },
                },
            };

            this.$validator.localize('en', dict);
        },
        methods: {
            ...mapActions('auth', ['login']),

            /**
             * Login user on submit
             * @returns {boolean}
             */
            async submit() {
                const validation = await this.$validator.validateAll();
                if (!validation) return;

                this.login(this.model);
            },
        },
    };
</script>

<style lang="stylus" scoped>
    .controls
        display: flex
        justify-content: space-between
        align-items: center
        flex-direction: row

        div
            width: calc(50% - 10px)

    .submit
        width: 100%

    .linksWrapper
        width: 100%
        display: flex
        justify-content: space-between
        align-items: center

    .link
        font-size: 14px
</style>
